import { CompanyPolicyModel } from "./companyPolicyModel";

export class EditCompanyPolicyModel extends CompanyPolicyModel{
    roleIds: string[];
    isDeleted: boolean;
}